import React, { Component } from 'react'
import './App.css';
import HostGame from './pages/HostGame'
import firebase from 'firebase'
import {login, userData} from './functions/firebase'
import {Redirect, Switch, Route, Link} from "react-router-dom";
import NewUser from './pages/NewUser'
import history from "./history";
import Home from './pages/Home'
import Nakbah from './pages/Nakbah';
import Loading from './pages/componnets/Loading';
import NotFound from './pages/componnets/NotFound';




export default class App extends Component {
  state={
    newUser : 'somethin' 
  }
  componentDidMount() {
     const addUser = userId => {
      this.setState({
      userId: userId 
    })

    
    let user = userData(this.state.userId).then(data =>{
      console.log(data);
      if(data.newUser){ 
        this.setState({newUser:data.newUser})

      }else{ 
        this.setState({
          newUser:data.newUser,
          userInfo: data.userInfo
        })

      }
    })
     

    }
 
 firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        var isAnonymous = user.isAnonymous;
        var uid = user.uid;
       addUser(user.uid)
        
        // ...
      } else {
        // User is signed out.
        // ...
      }
      // ...
    });

    console.log(this.state);
    
  } 
  userNotFound = userId => {
    // redirect to get more info
this.setState({newUser: true})
  }
  render() {
    console.log(this.state);
    
    return (
      <div>
        {this.state.newUser == true? <NewUser userid={this.state.userId}/>: '' }

        {this.state.newUser == false?
        
        <Switch>

        <Route exact path="/" component={Home}/>
        <Route path="/loading" component={Loading}/>
        <Route path="/createGame" component={HostGame} data={this.state.userInfo}/>
        <Route path="/nakbah/:gameId" component={Nakbah} /> 
        <Route path="/*" component={NotFound} /> 
     
      </Switch>
        : ''}
     
      </div>
    )
  }
}
